<nvps-side-nav class="navigation-wrapper"></nvps-side-nav>
<div class="outlet-wrapper">
  <page-banner 
  [meta]="pageBannerMeta"
  >
  </page-banner>
  <router-outlet></router-outlet>
</div>
